import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { AllRoutes } from "./Routes/AllRoutes";
import './App.css';


function App() {
  return (
    <>
      <Header />
      <AllRoutes />
      <Footer />
    </>
  );
}

export default App;
